import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kharaditomumbaicab() {



const cardData = {
  keyword: " Kharadi to Mumbai Cab ",

"headingDescription": "SRS Cab Service offers Kharadi to Mumbai Cab, providing a comfortable, safe, and reliable travel solution for corporate travelers, IT professionals, and leisure passengers. Our well-maintained vehicles, professional drivers, and punctual pickups ensure a smooth journey from Kharadi to Mumbai. Ideal for airport transfers, corporate trips, and personal travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a hassle-free and enjoyable ride.",
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Gateway of India is Mumbai’s iconic landmark overlooking the Arabian Sea. Travelers using Kharadi to Mumbai Cab from SRS Cab Service often visit this historic site for sightseeing and photography."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is a scenic seaside promenade famous for stunning sunset views. Visitors using SRS Cab Service often enjoy walking along this picturesque coastline."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are UNESCO-listed rock-cut caves located on an island near Mumbai. Travelers using SRS Cab Service often include this destination for historical and cultural exploration."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "This historic railway station features Victorian Gothic architecture. Visitors using SRS Cab Service often admire its grandeur and heritage significance."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is a lively coastal destination known for street food and leisure activities. Travelers using SRS Cab Service often visit to enjoy sunsets and local cuisine."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a renowned temple dedicated to Lord Ganesha. Visitors using SRS Cab Service often seek blessings and spiritual serenity."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered mosque on an islet in the Arabian Sea. Travelers using SRS Cab Service often visit for spiritual significance and scenic views."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling street in Mumbai known for shopping and cultural experiences. Travelers using SRS Cab Service often explore this area for dining and local souvenirs."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a large green area offering wildlife, trekking, and nature activities. Visitors using SRS Cab Service often enjoy outdoor recreation here."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is an iconic bridge connecting major areas of Mumbai. Travelers using SRS Cab Service often take this route for scenic views and a smooth drive."
  }
],



services: [
{
name: "Kharadi to Mumbai Cab",
description: "Kharadi to Mumbai cab offers reliable intercity travel for business and personal trips. Customers can book cabs for flexible journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Kharadi to Mumbai Airport Cab",
description: "Kharadi to Mumbai airport cab provides convenient transfer for passengers. Customers can book cabs for timely airport drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Kharadi to Mumbai Taxi Service",
description: "Kharadi to Mumbai taxi service offers dependable travel for long-distance journeys. Customers can book taxis for flexible trips. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Kharadi to Mumbai One Way Cab",
description: "Kharadi to Mumbai one way cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Kharadi to Mumbai International Airport Cab",
description: "Kharadi to Mumbai international airport cab provides premium airport transfer services. Customers can book cabs for smooth journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Cab Service in Kharadi Pune",
description: "Cab service in Kharadi Pune offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Kharadi to Andheri Cab",
description: "Kharadi to Andheri cab provides convenient travel for business and airport routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Kharadi to Dadar Cab Fare",
description: "Kharadi to Dadar cab fare provides estimated pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Kharadi to Mumbai Airport Drop",
description: "Kharadi to Mumbai airport drop offers direct transportation for timely travel. Customers can book cabs for quick airport drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport drop services."
},
{
name: "Kharadi to Mumbai Darshan Cabs",
description: "Kharadi to Mumbai darshan cabs offer sightseeing travel for tourists. Customers can book cabs for city tours and visits. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with darshan cab services."
},
{
name: "Kharadi to Mumbai Central Cabs",
description: "Kharadi to Mumbai Central cabs provide reliable travel for railway station routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Kharadi to Dadar Cab",
description: "Kharadi to Dadar cab offers convenient transportation for central Mumbai routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Chandan Nagar Mumbai Taxi",
description: "Chandan Nagar Mumbai taxi provides reliable intercity travel for customers. Users can book taxis for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab offers comfortable 7 seater travel for families. Customers can book vehicles for long-distance journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab provides spacious and comfortable SUV travel. Customers can enjoy premium seating and luggage space. Professional drivers ensure safe journeys. Ideal for family and corporate travel. Transparent pricing ensures value. Travel easily with Innova cab services."
},
{
name: "Pune Mumbai SRS Cab Service",
description: "Pune Mumbai SRS cab service provides dependable intercity travel for customers. Users can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Kharadi to Dadar Taxi",
description: "Kharadi to Dadar taxi offers reliable transportation for city travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Kharadi to Mumbai Cab Service",
description: "Kharadi to Mumbai cab service offers reliable intercity travel for customers. Users can book cabs for flexible journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Kharadi to Borivali Cab",
description: "Kharadi to Borivali cab provides convenient travel for long-distance routes. Customers can book cabs for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service in Kharadi",
description: "Cab service in Kharadi offers dependable transportation for local and outstation trips. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service Kharadi Pune",
description: "Cab service Kharadi Pune provides reliable travel solutions for daily and business needs. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab in Central Kharadi Pune",
description: "Cab in central Kharadi Pune offers convenient travel for nearby and intercity routes. Customers can book cabs easily for daily use. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Innova Crysta on Rent in Kharadi",
description: "Innova Crysta on rent in Kharadi offers premium SUV travel for outstation trips. Customers can enjoy luxury seating and comfort. Professional drivers ensure safe journeys. Ideal for family and corporate travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
}
],

tableData: [
["Kharadi to Mumbai Cab","Kharadi to Mumbai Airport Cab"],
["Kharadi to Mumbai Taxi Service","Kharadi to Mumbai One Way Cab"],
["Kharadi to Mumbai International Airport Cab","Cab Service in Kharadi Pune"],
["Kharadi to Andheri Cab","Kharadi to Dadar Cab Fare"],
["Kharadi to Mumbai Airport Drop","Kharadi to Mumbai Darshan Cabs"],
["Kharadi to Mumbai Central Cabs","Kharadi to Dadar Cab"],
["Chandan Nagar Mumbai Taxi","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Pune Mumbai SRS Cab Service"],
["Kharadi to Dadar Taxi","Kharadi to Mumbai Cab Service"],
["Kharadi to Borivali Cab","Cab Service in Kharadi"],
["Cab Service Kharadi Pune","Cab in Central Kharadi Pune"],
["Innova Crysta on Rent in Kharadi","Kharadi to Mumbai Airport Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Quick Pickup from Kharadi & IT Park Areas",
    WhyChoosedescription: "SRS Cab Service provides fast pickup from Kharadi, EON IT Park, WTC, Viman Nagar, and nearby areas for smooth travel to Mumbai."
  },
  {
    WhyChooseheading: "Affordable Kharadi to Mumbai Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly cab services from Kharadi to Mumbai with transparent pricing. Customers receive full fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on the Mumbai-Pune Expressway, ensuring safe, fast, and comfortable travel between Kharadi and Mumbai."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Kharadi to Mumbai cab bookings, ideal for airport transfers, corporate travel, and emergency trips."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles ensuring a smooth and relaxing journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, and same-day return options based on your travel needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and groups."
  },
  {
    WhyChooseheading: "Trusted Kharadi to Mumbai Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Kharadi to Mumbai cab bookings due to punctual service, professional drivers, and reliable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Kharadi to Mumbai cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Kharadi to Mumbai." },
  { question: "How far is Mumbai from Kharadi?", answer: "The distance is approximately 150–160 km and takes around 3 to 4 hours via expressway." },
  { question: "What is the starting cab fare?", answer: "Cab fares typically start from ₹1800–₹2600 for sedan depending on availability and timing." },
  { question: "Is one-way cab available?", answer: "Yes, one-way cab services are available and are more affordable than round-trip bookings." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide Mumbai Airport drop?", answer: "Yes, we provide drop service to Mumbai Airport including T1 and T2 terminals." },
  { question: "Can I book cab online?", answer: "Yes, you can easily book Kharadi to Mumbai cab service online or via phone." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, offices, and IT parks in Kharadi." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Patil",
    feedback:
      "Booked cab from Kharadi to Mumbai Airport. On-time pickup and very smooth journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best Kharadi to Mumbai cab service. Clean car, professional driver, and great experience.",
    rating: 5
  }
];
























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Kharadi to Mumbai Cab Service | SRS Cab Service",
  "description": "Book reliable Kharadi to Mumbai cabs for airport transfers, one-way or round trips. Innova, Ertiga, and Sedan cabs available with 24x7 online booking.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Kharadi",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411014",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5302",
    "longitude": "73.9143"
  },
  "url": "https://www.srscabservice.com/kharadi-to-mumbai-cab",
  "areaServed": ["Kharadi", "Pune", "Mumbai", "Mumbai Airport", "Dadar", "Andheri", "Bandra", "Chandan Nagar"],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Kharadi to Mumbai Cab",
    "Kharadi to Mumbai Airport Cab",
    "One-way and round-trip cabs",
    "Innova, Ertiga, Sedan"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "710"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Kharadi to Mumbai Cab Service | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Book Kharadi to Mumbai cabs with SRS Cab Service. One-way, round trip, and airport transfers. Innova, Ertiga, and Sedan cabs available 24x7 online."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kharaditomumbaicab;